/* Approved Natural NUME material A viewer; existing story viewer owns locks/focus. */
(() => {
  'use strict';
  const configurations = [
    ['[data-cm-dulles-story]', 'ds', 'cmDS'],
    ['[data-cm-smart-story]', 'ss', 'cmSS'],
    ['[data-cm-mini-story]', 'ms', 'cmMS']
  ];

  function initialize(root, prefix, apiName) {
    const id = `cm-${prefix}-nume-material-a`;
    if (root.querySelector(`#${id}`)) return;
    const source = root.querySelector(`[data-cm-${prefix}-material]`);
    const cards = Array.from(root.querySelectorAll('.material-grid > article'));
    const api = root[apiName];
    if (!source || cards.length !== 3 || !api?.open || !api?.restore) return;
    const items = JSON.parse(source.textContent).items;
    if (!Array.isArray(items) || items.length !== 3 || items.some(item => !item.title || !Array.isArray(item.paragraphs))) {
      throw new Error('Expected three complete material descriptions');
    }
    const dialog = document.createElement('dialog');
    dialog.id = id;
    dialog.className = 'cm-nume-material-a';
    dialog.setAttribute('aria-labelledby', `${id}-title`);
    dialog.innerHTML = `<div class="cm-nume-material-a__shell">
      <div class="cm-nume-material-a__header"><span>素材と仕立て</span><button type="button" class="cm-nume-material-a__close" aria-label="素材の説明を閉じる">×</button></div>
      <div class="cm-nume-material-a__main"><div class="cm-nume-material-a__photo"><img alt=""></div><div class="cm-nume-material-a__copy">
        <div class="cm-nume-material-a__heading"><p class="cm-nume-material-a__eyebrow"></p><h2 id="${id}-title"></h2><p class="cm-nume-material-a__subtitle"></p></div>
        <div class="cm-nume-material-a__tabs" role="tablist" aria-label="説明の種類"><button type="button" id="${id}-explanation-tab" role="tab" aria-controls="${id}-text" data-text-tab="explanation">革について</button><button type="button" id="${id}-maintenance-tab" role="tab" aria-controls="${id}-text" data-text-tab="maintenance">お手入れ</button></div>
        <div id="${id}-text" class="cm-nume-material-a__body" role="tabpanel" tabindex="0"></div>
      </div></div>
      <nav class="cm-nume-material-a__nav" aria-label="素材・仕立てを切り替える"><button type="button" data-material-prev aria-label="前の説明へ">← 前へ</button><span class="cm-nume-material-a__count" aria-live="polite" aria-atomic="true"></span><button type="button" data-material-next aria-label="次の説明へ">次へ →</button></nav>
    </div>`;
    const query = selector => dialog.querySelector(selector);
    const image = query('img');
    const title = query('h2');
    const body = query('.cm-nume-material-a__body');
    const main = query('.cm-nume-material-a__main');
    const closeButton = query('.cm-nume-material-a__close');
    const tabs = Array.from(dialog.querySelectorAll('[role="tab"]'));
    let current = 0;
    let activeTab = 'explanation';

    function selectTab(name, focus = false) {
      const care = items[current].maintenance?.paragraphs;
      activeTab = name === 'maintenance' && Array.isArray(care) ? 'maintenance' : 'explanation';
      tabs.forEach(tab => {
        const selected = tab.dataset.textTab === activeTab;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus({ preventScroll: true });
      });
      body.setAttribute('aria-labelledby', `${id}-${activeTab}-tab`);
      body.replaceChildren(...(activeTab === 'maintenance' ? care : items[current].paragraphs).map(text => {
        const paragraph = document.createElement('p');
        paragraph.textContent = text;
        return paragraph;
      }));
      body.scrollTop = 0;
    }

    function show(index) {
      current = ((index % items.length) + items.length) % items.length;
      const item = items[current];
      const suppliedImage = typeof item.image === 'string' ? item.image : item.image?.src;
      image.src = suppliedImage || cards[current].querySelector('img').src;
      image.alt = item.imageAlt || item.image?.alt || item.cardTitle || item.title;
      title.textContent = item.title;
      query('.cm-nume-material-a__subtitle').textContent = '';
      query('.cm-nume-material-a__eyebrow').textContent = item.eyebrow || '';
      const type = String(item.eyebrow || '').toLowerCase();
      tabs[0].textContent = type === 'leather' ? '革について' : type === 'fabric' ? '生地について' : '仕立てについて';
      tabs[1].hidden = !Array.isArray(item.maintenance?.paragraphs);
      query('.cm-nume-material-a__count').textContent = `${current + 1} / ${items.length}`;
      main.scrollTop = 0;
      selectTab('explanation');
    }
    function restore() { api.restore(dialog); }
    function close() { if (dialog.open) { dialog.close(); restore(); } }
    function open(index, trigger) {
      show(index);
      api.open(dialog, trigger);
      closeButton.focus({ preventScroll: true });
    }

    root.append(dialog);
    cards.forEach((card, index) => {
      card.classList.add('cm-nume-material-a-card');
      const photo = card.querySelector('img');
      if (!photo) throw new Error('Material card photo missing');
      let pictureButton = photo.closest('button.material-picture-trigger');
      if (!pictureButton) {
        pictureButton = document.createElement('button');
        pictureButton.type = 'button';
        pictureButton.className = 'material-picture-trigger';
        photo.replaceWith(pictureButton);
        pictureButton.append(photo);
      }
      pictureButton.setAttribute('aria-label', `${items[index].cardTitle || items[index].title}の説明を見る`);
      let link = card.querySelector('button.material-more');
      if (!link) {
        link = document.createElement('button');
        link.type = 'button';
        link.className = 'material-more';
        card.append(link);
      }
      link.textContent = index === 2 ? '仕立てについて詳しく' : '素材について詳しく';
      [pictureButton, link].forEach(button => {
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', id);
        button.addEventListener('click', () => open(index, button));
      });
    });
    closeButton.addEventListener('click', close);
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('close', () => { if (!dialog.open) restore(); });
    query('[data-material-prev]').addEventListener('click', () => show(current - 1));
    query('[data-material-next]').addEventListener('click', () => show(current + 1));
    tabs.forEach(tab => {
      tab.addEventListener('click', () => selectTab(tab.dataset.textTab));
      tab.addEventListener('keydown', event => {
        const visible = tabs.filter(button => !button.hidden);
        const index = visible.indexOf(tab);
        let target;
        if (event.key === 'ArrowRight') target = visible[(index + 1) % visible.length];
        if (event.key === 'ArrowLeft') target = visible[(index + visible.length - 1) % visible.length];
        if (event.key === 'Home') target = visible[0];
        if (event.key === 'End') target = visible[visible.length - 1];
        if (target) { event.preventDefault(); selectTab(target.dataset.textTab, true); }
      });
    });
    dialog.addEventListener('keydown', event => {
      if (event.target.closest('.cm-nume-material-a__nav') && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    root.addEventListener('product-viewer-open', event => { if (event.detail?.id !== id) close(); });
    root.addEventListener('click', event => { if (event.target.closest('[data-detail], [data-color-view]')) close(); }, true);
  }

  configurations.forEach(([selector, prefix, apiName]) => {
    document.querySelectorAll(selector).forEach(root => {
      try { initialize(root, prefix, apiName); }
      catch (error) { console.error('Natural NUME material A:', error); }
    });
  });
})();
